/*Edit thong tin ve nguon tin va tai nan, phuong tien bi nan */
import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import SelectFilter from "react-select";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import MyLatLonEditor from "./LatLonEditor";

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const sukienLayer = require("../../lib/SuKienDataLayer");
///////////////////////////////////////////////////////////////////
const defaultRecord = {
  DuocCuu_NguoiVN: 0,
  DuocCuu_NguoiNN: 0,
  DuocCuu_GhiChu: null,
  TrucTiep_NguoiVN: 0,
  TrucTiep_NguoiNN: 0,
  TrucTiep_GhiChu: null,
  GianTiep_NguoiVN: 0,
  GianTiep_NguoiNN: 0,
  GianTiep_GhiChu: null,
  BiThuong: 0,
  BiChet: 0,
  MatTich: 0,
  TrucTiep_PhuongTien: 0,
  GianTiep_PhuongTien: 0,
  BiDam: 0,
};

class SuKienKetQuaChiTietControl extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      //danh muc quoc gia
      loading_quoctich: true, // co dang loading danh muc quoc gia khong
      source_quoctich: [], //danh muc options cho quoc tich
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
          after:
          props.value === undefined
          ? defaultRecord
          : { ...defaultRecord, ...props.value }, //thong tin dang edit
      validateStatus: {},   
    };
  }
  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var old_changed = this.state.dataChanged;
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = !myLib.isSame(s.before, s.after, ['DuocCuu_NguoiVN', 'DuocCuu_NguoiNN', 'DuocCuu_GhiChu', 'TrucTiep_NguoiVN', 'TrucTiep_NguoiNN', 'TrucTiep_GhiChu', 'GianTiep_NguoiVN', 'GianTiep_NguoiNN', 'GianTiep_GhiChu', 'BiThuong', 'BiChet', 'MatTich', 'TrucTiep_PhuongTien', 'GianTiep_PhuongTien', 'BiDam']);
    s.canSaved = s.dataChanged;
    if(this.props.onChanged && old_changed != s.dataChanged) {
      this.props.onChanged(s.dataChanged);
    }
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSave = () => {
    console.log(JSON.stringify(this.state.after));
    var check = sukienLayer.validate("ketqua", this.state.after);
    if (!check.error) {
      this.setState({ validateStatus: check, saving: true, errorLog: "" });      
      server
        .post(
          "sukien/saveKetQuaChiTiet",
          sukienLayer.chuanHoaSukien("ketqua", this.state.after)
        )
        .then((response) => {
          var before = {};
          var after = this.state.after;
          Object.assign(before, after);
          this.setState({
            before: before,
            after: after,
            dataChanged: false,
            canSaved: false,
            saving: false,
            errorLog: "",
          });
          //thong bao cho parent biet co data duoc saved
          if (this.props.onSaved) {
            this.props.onSaved(after);
          }
          if(this.props.onChanged) {
            this.props.onChanged(false);
          }
        })
        .catch((error) =>
          this.setState({ saving: false, errorLog: error + "" })
        );
    } else {
      this.setState({ validateStatus: check });
    }
  };
  loadDanhMuc() {
    //load danh muc tai nan
    server
      .query("quocgia/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.MaQG, label: item.TenQuocGia })
        );
        this.setState({ source_quoctich: list, loading_quoctich: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_quoctich: false });
      });
  }
  //khi load component: load cac danh muc can thiet
  componentDidMount() {
    this.loadDanhMuc();
  }
  static getDerivedStateFromProps(props, state) {
    var newState = { ...state };
    //console.log("TaiNanControl props:", props.value);
    if (props.value !== undefined && props.value.MaSK !== state.after.MaSK) {
      //console.log("co su thay doi");
      //co su thay doi
      newState = {
        ...newState,
        after: { ...state.after, ...props.value },
      }; //lay thong tin tu parent form truyen vao thong qua props
    }
    //console.log("TaiNanControl new state:", newState);
    return newState;
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <Accordion disabled={this.props.disabled} 
      defaultExpanded={this.props.value !== undefined}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{
            root: classes.normalPanel,
            expanded: classes.expandedPanel,
            content: classes.summaryContent
          }}
        >
          <Typography className={classes.heading}>Chi tiết kết quả</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <TextField
                id="txtDuocCuu_NguoiVN"
                className={classes.textbox}
                label="Người VN được cứu:"
                type="number"
                value={this.state.after.DuocCuu_NguoiVN}
                inputProps={{
                  maxLength: 6,
                }}
                onChange={(event) =>
                  this.saveField("DuocCuu_NguoiVN", event.target.value)
                }
                onFocus={event => {
                  event.target.select();
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtDuocCuu_NguoiNN"
                className={classes.textbox}
                label="Người NN được cứu:"
                type="number"
                value={this.state.after.DuocCuu_NguoiNN}
                inputProps={{
                  maxLength: 6,
                }}
                onChange={(event) =>
                  this.saveField("DuocCuu_NguoiNN", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtDuocCuu_GhiChu"
                className={classes.textbox}
                label="Ghi chú:"
                value={this.state.after.DuocCuu_GhiChu}
                inputProps={{
                  maxLength: 50,
                }}
                onChange={(event) =>
                  this.saveField("DuocCuu_GhiChu", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtTrucTiep_NguoiVN"
                className={classes.textbox}
                label="Hỗ trợ người VN:"
                type="number"
                value={this.state.after.TrucTiep_NguoiVN}
                inputProps={{
                  maxLength: 6,
                }}
                onChange={(event) =>
                  this.saveField("TrucTiep_NguoiVN", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtTrucTiep_NguoiNN"
                className={classes.textbox}
                label="Hỗ trợ người NN:"
                type="number"
                value={this.state.after.TrucTiep_NguoiNN}
                inputProps={{
                  maxLength: 6,
                }}
                onChange={(event) =>
                  this.saveField("TrucTiep_NguoiNN", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtTrucTiep_GhiChu"
                className={classes.textbox}
                label="Ghi chú:"
                value={this.state.after.TrucTiep_GhiChu}
                inputProps={{
                  maxLength: 50,
                }}
                onChange={(event) =>
                  this.saveField("TrucTiep_GhiChu", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtGianTiep_NguoiVN"
                className={classes.textbox}
                label="Hỗ trợ gián tiếp người VN:"
                type="number"
                value={this.state.after.GianTiep_NguoiVN}
                inputProps={{
                  maxLength: 6,
                }}
                onChange={(event) =>
                  this.saveField("GianTiep_NguoiVN", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtGianTiep_NguoiNN"
                className={classes.textbox}
                label="Hỗ trợ gián tiếp người NN:"
                type="number"
                value={this.state.after.GianTiep_NguoiNN}
                inputProps={{
                  maxLength: 6,
                }}
                onChange={(event) =>
                  this.saveField("GianTiep_NguoiNN", event.target.value)
                }
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtGianTiep_GhiChu"
                className={classes.textbox}
                label="Ghi chú:"
                value={this.state.after.GianTiep_GhiChu}
                inputProps={{
                  maxLength: 50,
                }}
                onChange={(event) =>
                  this.saveField("GianTiep_GhiChu", event.target.value)
                }
              />
              </Grid>
              <Grid item xs={2}>
              <TextField
                id="txtBiThuong"
                className={classes.textbox}
                label="Số bị thương:"
                type="number"
                value={this.state.after.BiThuong}
                inputProps={{
                  maxLength: 6,
                }}
                onChange={(event) =>
                  this.saveField("BiThuong", event.target.value)
                }
              />              
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtBiChet"
                className={classes.textbox}
                label="Số bị chết:"
                type="number"
                value={this.state.after.BiChet}
                inputProps={{
                  maxLength: 6,
                }}
                onChange={(event) =>
                  this.saveField("BiChet", event.target.value)
                }
              />              
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtMatTich"
                className={classes.textbox}
                label="Số mất tích:"
                type="number"
                value={this.state.after.MatTich}
                inputProps={{
                  maxLength: 6,
                }}
                onChange={(event) =>
                  this.saveField("MatTich", event.target.value)
                }
              />              
            </Grid>                        
            <Grid item xs={4}>
              {this.state.canSaved ? (
                <MyButton
                  onClick={this.handleSave}
                  color="primary"
                  text="Lưu"
                />
              ) : null}
            </Grid>
            <Grid item xs={10}>
              {this.state.saving ? (
                <CircularProgress />
              ) : this.state.errorLog === "" ? null : (
                this.state.errorLog
              )}
            </Grid>   
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },

  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: "100%",
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
    margin: 0,
    minHeight: 11,
  },
  expandedPanel: {
    backgroundColor: "skyblue",
    margin: 0,
    minHeight: '10px !important',
  },
  summaryContent: {
    margin: '1px !important',
  },
  normalLabel: {
    color: 'black',
  },
  redLabel: {
    color: 'red',
  }  
});
export default withStyles(styles, { withTheme: true })(
  SuKienKetQuaChiTietControl
);
